<template>
  <asc-page-loading-indicator
    :loading="isDataLoading && !apiPageFailure.length"
  >
    <v-container fluid class="asc-help-container">
      <asc-page-header>
        <template #pageTitle><asc-page-title title="HELP & ABOUT" /></template>
      </asc-page-header>
      <asc-help-and-about-template
        :contact="contact"
        :pdf-document="userGuide"
        :version="frontendVersion"
      />
    </v-container>
  </asc-page-loading-indicator>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import AscPageLoadingIndicator from '@/components/molecules/AscPageLoadingIndicator'
import { AscHelpAndAboutTemplate } from '@/components/templates'
import { USER_CONSTS as UC } from '@/stores/consts'
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscPageTitle from '@/components/atoms/AscPageTitle'
import { ASC_HELP_CONTACT } from '@/utilities/appConsts'

export default {
  name: 'AscHelpContainer',

  components: {
    AscHelpAndAboutTemplate,
    AscPageLoadingIndicator,
    AscPageHeader,
    AscPageTitle,
  },

  data() {
    return {
      contact: ASC_HELP_CONTACT,
      isDataLoading: false,
      frontendVersion: process.env.FRONTEND_VERSION,
    }
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(UC.NAMESPACE, ['userGuide']),
    ...mapGetters(UC.NAMESPACE, ['isAirlineUser']),
  },

  mounted() {
    this.getUserGuide()
  },

  methods: {
    ...mapActions(UC.NAMESPACE, [UC.GET_USER_HELP_GUIDE]),
    async getUserGuide() {
      this.isDataLoading = true
      await Promise.all([this[UC.GET_USER_HELP_GUIDE](this.isAirlineUser)])
      this.isDataLoading = false
    },
  },
}
</script>

<style lang="scss">
.asc-help-container {
  background-color: $gray-100;

  & .container {
    padding: 16px;
  }
}
</style>
